import * as S from "../../Style/Page/Car.style.js";
import { Link } from "react-router-dom";
import { ReactComponent as Home } from "../../assets/icon/home.svg";
import Arrow from "../../assets/icon/lnb_arrow.png";
import PageTitle from "../../Component/PageTitleCar.js";
import HatPageTopLine from "../../Component/CarPageTopLine.js";
const FactoryImg = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/18. 베트남법인.6fd165915558575ebfbd.png`;
// const Bus1 = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/19. 베트남법인 G8.42ab14d0d066a146bf9c.png`;
// const Bus3 = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/21. 베트남법인 G12.7e5899fe239aeaf3a011.png`;
// const Bus5 = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/23. 베트남법인 BS106.0c1fe498f535675dbde6.png`;
// const Bus6 = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/24. 베트남법인 BC095.4edb6a3301f5fba98365.png`;
import Bus1 from "../../assets/BusBusiness/베트남버스1.png";
import Bus3 from "../../assets/BusBusiness/베트남버스2.png";
import Bus5 from "../../assets/BusBusiness/베트남버스3.png";
import Bus6 from "../../assets/BusBusiness/베트남버스4.png";
import FactoryInner from "../../assets/BusBusiness/베트남공장내부.jpg";
// const FactoryInner = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/사진 11.752196bd5602c14f08c9.jpg`;
const Factory = () => {
  return (
    <S.Page className={localStorage.getItem("language")}>
      <HatPageTopLine name={"상용버스사업"} />
      <section className="section" id="hat-introduce-section">
        <S.PageNavidation>
          <Link to="/" className="logo">
            <Home />
          </Link>
          <S.Nav height={"364px"}>
            <S.NavItem>
              <Link to="/BusBusiness/OverseasBus">
                <div className="kor">버스사업</div>
                <div className="eng">Bus Business</div>
              </Link>
            </S.NavItem>

            <div className="open-list">
              <S.NavItem className="list-inner-item">
                <Link to="/HatBusiness/Introduce">
                  <div className="kor">모자사업</div>
                  <div className="eng">Hat Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/ForkLiftBusiness/Introduce">
                  <div className="kor">지게차사업</div>
                  <div className="eng">Fork Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/CarBusiness/introduce">
                  <div className="kor">자동차사업</div>
                  <div className="eng">Car Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/BusBusiness/OverseasBus">
                  <div className="kor">버스사업</div>
                  <div className="eng">Bus Business</div>
                </Link>
              </S.NavItem>

              <S.NavItem className="list-inner-item">
                <Link to="/GeneralBusiness/introduce">
                  <div className="kor">일반사업</div>
                  <div className="eng">General Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/SocialBusiness/SocialService">
                  <div className="kor">사회사업</div>
                  <div className="eng">Social Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/WBH/WBH">WBH</Link>
              </S.NavItem>
            </div>
            <img src={Arrow} className="down-arrow" alt="" />
          </S.Nav>

          <S.Nav height={"156px"}>
          <S.NavItem>
              <Link to="/BusBusiness/Factory">
                <div className="kor">생산공장</div>
                <div className="eng">production plant</div>
              </Link>
            </S.NavItem>
            <div className="open-list">
              <S.NavItem className="list-inner-item">
                <Link to="/BusBusiness/OverseasBus">
                  <div className="kor">해외 상용버스사업</div>
                  <div className="eng">Overseas commercial bus business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/BusBusiness/Factory">
                  <div className="kor">생산공장</div>
                  <div className="eng">production plant</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/BusBusiness/BusBusinessHistory">
                  <div className="kor">버스사업이력</div>
                  <div className="eng">Major business history</div>
                </Link>
              </S.NavItem>
            </div>
            <img src={Arrow} className="down-arrow" alt="" />
          </S.Nav>

          <S.Nav height={"270px"}>
            <S.NavItem>
              <Link to="/BusBusiness/Factory">
                <div className="kor">베트남 법인</div>
                <div className="eng">Vietnam Production Plant</div>
              </Link>
            </S.NavItem>
            <div className="open-list">
              <S.NavItem className="list-inner-item">
                <Link to="/BusBusiness/Factory">
                  <div className="kor">베트남 법인</div>
                  <div className="eng">Vietnam Production Plant</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/BusBusiness/Factory2">
                  <div className="kor">베트남 부품공장</div>
                  <div className="eng">Vietnam Parts Manufacturing</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/BusBusiness/Factory3">
                  <div className="kor">중국 계림 법인</div>
                  <div className="eng">China Production Plant</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/BusBusiness/Factory4">
                  <div className="kor">파키스탄 법인</div>
                  <div className="eng">Pakistan Production Plant</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/BusBusiness/Factory5">
                  <div className="kor">카자흐스탄 법인</div>
                  <div className="eng">Kazakhstan Production Plant</div>
                </Link>
              </S.NavItem>
              {/* <S.NavItem className="list-inner-item">
                <Link to="/BusBusiness/Factory6">
                  <div className="kor">코스타리카 법인</div>
                  <div className="eng">Costa Rica Sales Corporation</div>
                </Link>
              </S.NavItem> */}
            </div>
            <img src={Arrow} className="down-arrow" alt="" />
          </S.Nav>
        </S.PageNavidation>
        <div className="wrap">
          <div className="inner">
            <PageTitle
              titleko={"베트남 공장"}
              titleeng={"Production Plant"}
              website={"http://www.daewoobus.com.vn/"}
            />
            <div className="page-text"><h2>1. Vietnam Daewoo Bus Co., Ltd.</h2></div>

            <S.ImgHolderFullsize>
              <img src={FactoryImg} className="holder-img" alt="" />
              <div className="holder-name">
                <div className="kor">베트남 공장</div>
                <div className="eng">Vietnam Daewoo Bus</div>
              </div>
            </S.ImgHolderFullsize>
            <PageTitle titleko={"공장 내부 / 주요 생산 / 판매차종"} titleeng={"Factory Interior / Major Product / Sales model"} />
            <S.ImgHolderFlex className="start">
              <S.ImgHolderHarf>
                <img src={FactoryInner} className="holder-img" alt="" />
                  <div className="holder-name">
                    <div className="kor">공장 내부</div>
                    <div className="eng">Factory Interior</div>
                </div>
              </S.ImgHolderHarf>
              <div className="sale-bus-list flex-right">
                <div className="sale-bus-item">
                  <img src={Bus1} alt="" className="sale-bus-img" />
                  <div className="sale-bus-name">EV6 / EV8(전기버스)</div>
                </div>
                <div className="sale-bus-item">
                  <img src={Bus3} alt="" className="sale-bus-img" />
                  <div className="sale-bus-name">BS090 / BS106</div>
                </div>
                <div className="sale-bus-item">
                  <img src={Bus5} alt="" className="sale-bus-img" />
                  <div className="sale-bus-name">G8</div>
                </div>
                <div className="sale-bus-item">
                  <img src={Bus6} alt="" className="sale-bus-img" />
                  <div className="sale-bus-name">G12</div>
                </div>
                

                
              </div>
            </S.ImgHolderFlex>

            <PageTitle titleko={"주요 이력"} titleeng={"Key History"} />
            <div className="page-text">
              <div className="page-text-flex">
                <div className="page-text-area">
                  <div className="page-text-title">
                    <div className="kor">Vietnam Daewoo Bus Co., Ltd. 법인개요</div>
                    <div className="eng">Vietnam Daewoo Bus Co., Ltd. Status</div>
                  </div>
                  <div className="kor">법인 설립: 2005년 10월 26일 (자일자동차 100% 지분)</div>
                  <div className="eng">Established: 2005. 10. 26 (100% Zyle Motors)</div>
                </div>
              </div>
              <div className="kor">
                ※ 공장규모: 부지 24,953평 / 건물 3,806평
                <br />
                ※ 연간 생산능력: 1,200대(8T 기준)
                <br />※ 중대형 버스 및 부품, KD 생산/판매
              </div>
              <div className="eng">
                ※ Factory Size: land 82,500 square meters / building 12,600 square meters <br />
                ※ Annual Capa.: 1,200 units(8T basis) <br />
                ※ Mid and Large bus & parts, KD manufacturing / sales <br />
              </div>
            </div>
          </div>
        </div>
      </section>
    </S.Page>
  );
};

export default Factory;
